import { useEffect, useState } from 'react';
import { userApi } from '../../lib/api';

/**
 * Debounced user search for the Invite Manager dialog.
 * Triggers a search when `query` is at least 3 characters; debounce 300ms.
 */
export function useUserSearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    if (searchQuery.length < 3) {
      setSearchResults([]);
      setShowResults(false);
      return undefined;
    }
    const timer = setTimeout(async () => {
      setSearching(true);
      try {
        const result = await userApi.search(searchQuery);
        setSearchResults(result.users || []);
        setShowResults(true);
      } catch (err) {
        console.error('Search failed:', err);
        setSearchResults([]);
        setShowResults(true);
      } finally {
        setSearching(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const reset = () => {
    setSearchQuery('');
    setSearchResults([]);
    setShowResults(false);
  };

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    searching,
    showResults,
    setShowResults,
    reset,
  };
}
